import { uniqueId } from 'lodash';
import {
  IconAperture,
  IconMailAi,
  IconActivityHeartbeat,
  IconMusic,
  IconMicrophone,
  IconRobot,
  IconTransform,
  IconScale,
  IconUsersGroup,
} from '@tabler/icons-react';
import i18n from '@shared/utils/i18n';
import { IconCampaigns } from '@shared/assets/images/svgs';
import type { Privilege } from '@shared/services/apiService';

interface MenuitemsType {
  [x: string]: any;
  id?: string;
  navlabel?: boolean;
  subheader?: string;
  title?: string;
  icon?: any;
  href?: string;
  children?: MenuitemsType[];
  chip?: string;
  chipColor?: string;
  variant?: string;
  external?: boolean;
  /** Shown only to users holding at least one of these. */
  requiredPrivileges?: Privilege[];
}

export const AdminMenuItems: MenuitemsType[] = [
  // {
  //   id: uniqueId(),
  //   title: i18n.t('adminMainPage.menuItems.dashboard'),
  //   icon: IconHome,
  // },

  {
    id: uniqueId(),
    title: i18n.t('adminMainPage.menuItems.campaigns'),
    icon: IconCampaigns,
    href: '/admin/campaign',
  },
  {
    id: uniqueId(),
    title: i18n.t('adminMainPage.menuItems.assistants'),
    icon: IconRobot,
    href: '/admin/assistants',
  },
  {
    id: uniqueId(),
    title: i18n.t('adminMainPage.menuItems.accessControl'),
    icon: IconUsersGroup,
    href: '/admin/access',
    requiredPrivileges: ['user.manage', 'group.manage'],
  },
  // {
  //   id: uniqueId(),
  //   title: i18n.t('adminMainPage.menuItems.settings'),
  //   icon: IconSettings,
  // },
];

export const SuperAdminMenuItems: MenuitemsType[] = [
  {
    id: uniqueId(),
    title: i18n.t('superAdminMainPage.menuItems.companies'),
    icon: IconAperture,
    href: '/super-admin/companies',
  },
  {
    id: uniqueId(),
    title: i18n.t('superAdminMainPage.menuItems.monitorConversation'),
    icon: IconMailAi,
    href: '/super-admin/conversation/monitor',
  },
  {
    id: uniqueId(),
    title: i18n.t('superAdminMainPage.menuItems.tokensMonitoring'),
    icon: IconActivityHeartbeat,
    href: '/super-admin/tokens-monitoring',
  },
  {
    id: uniqueId(),
    title: i18n.t('superAdminMainPage.menuItems.ambienceSounds'),
    icon: IconMusic,
    href: '/super-admin/ambience-sounds',
  },
  {
    id: uniqueId(),
    title: i18n.t('superAdminMainPage.menuItems.voiceSettings'),
    icon: IconMicrophone,
    href: '/super-admin/voice-settings',
  },
  {
    id: uniqueId(),
    title: i18n.t('superAdminMainPage.menuItems.transcriberManagement'),
    icon: IconTransform,
    href: '/super-admin/transcriber/management',
  },
  {
    id: uniqueId(),
    title: i18n.t('superAdminMainPage.menuItems.unitWeights'),
    icon: IconScale,
    href: '/super-admin/unit-weights',
  },
];

export default AdminMenuItems;
